import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NavComponent } from '../nav/nav.component'
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-insuropedia-result',
  templateUrl: './insuropedia-result.component.html',
  styleUrls: ['./insuropedia-result.component.css']
})
export class InsuropediaResultComponent implements OnInit {
  private message: Observable<any>;
  insuroTitle: any;
  insuroUrl: any;
  insuroContent: any;
  insuroData: Array<any> = [];
  loading: boolean;
  searchKey: any;
  searchContent: any;

  constructor(private serviceURLService: serviceURLService) {
    
  }



  ngOnInit() {
      this.getInsuroContent();
  }

  

  getInsuroContent(){
    this.loading = true;
    this.searchKey = localStorage.getItem('insuroSearchContent');
    this.serviceURLService.getInsuropediaResult(this.searchKey).subscribe((successData:any) => {
        this.insuroData = successData.response;
        this.loading = false;
    });
  }

  searchInsuropediaResult(value){
    this.loading = true;
    localStorage.removeItem("insuroSearchContent")
    localStorage.setItem("insuroSearchContent",value)
    this.searchKey = localStorage.getItem('insuroSearchContent');
    this.serviceURLService.getInsuropediaResult(this.searchKey).subscribe((successData:any) => {
        this.insuroData = successData.response;
        console.log("successData ",this.insuroData)
        this.loading = false;
    });
  }

  ngOnDestroy(){
    localStorage.removeItem("insuroSearchContent")
  }


}
